import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import Card from '../../../components/Card';
import { Caption1 } from '../../../components/Typography';
import appConfig from '../../../../app-config';
import PaymentMethodDetails from './PaymentMethodDetails';
import { Box, TextField, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: '#fff',
    borderRadius: 4,
    maxWidth: 150,
  },
  input: {
    border: 'none',
    padding: '10px 12px',
  },
  notchedOutline: {
    border: 'none',
  },
}));

const PaymentMenthodWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 16px;
  align-items: center;
  margin-bottom: 10px;
`;

const Wrapper = styled(Card)`
  max-width: 384px;
  min-width: 307px;
  padding: 19px 16px;
  cursor: pointer;
  position: relative;
  display: grid;
  grid-template-columns: auto auto 1fr;
  grid-template-areas:
    'col1 col2 col3'
    'cvv cvv cvv';
  grid-template-rows: auto auto;
  justify-content: flex-start;
  align-items: center;
  grid-gap: 32px;
  grid-row-gap: 10px;
  grid-column: 1 / -1;
  box-shadow: none;
  background-color: #f1f1f1;
  :hover {
    background-color: ${(props) => props.theme.paymentCardColorHover};
    transition: all 0.25s ease;
  }
  @media (max-width: 786px) {
    grid-column: ${(props) => (props.editStateIsVisible ? '2 / -1' : '1 / -1')};
    //max-width: 320px;
  }
  & > :nth-child(1) {
    grid-area: col1;
  }
  & > :nth-child(2) {
    grid-area: col2;
  }
  & > :nth-child(3) {
    grid-area: col3;
  }
  & > :nth-child(4) {
    grid-area: cvv;
  }
`;
//width: ${props => !props.isForCheckoutPage && '400px'};
const RemoveIcon = styled.i`
  cursor: pointer;
  position: absolute;
  // left: -32px;
  left: -22px;
  top: 50%;
  transform: translateY(-50%);
  color: ${(props) => props.theme.danger};
  // font-size: 20px;
  font-size: 18px;
  @media (max-width: 786px) {
    display: none;
  }
`;

const RemoveIconMobile = styled.i`
  color: ${(props) => props.theme.danger};
  @media (min-width: 786px) {
    display: none;
  }
`;

const CardWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-gap: 8px;
  justify-content: flex-start;
  align-items: center;
`;

const PaymentMethodPreview = ({
  paymentMethod,
  setDefaultPaymentMethod,
  editStateIsVisible,
  initiateDeletePaymentMethod,
  isForCheckoutPage,
  showGiftCardModal,
  initiateReloadGiftCard,
  reloadGiftCard,
  requestingDeletePaymentMethod,
  confirmDeletePaymentMethodIsVisible,
  isForGiftCard,
  showPaymentMethodSelectionForm,
  cvvRequired = false,
  cvv,
  setCvv,
}) => {
  const [state, setState] = useState(false);
  const {
    last_four,
    card_type,
    expiry_date,
    balance,
  } = paymentMethod?.details || {
    last_four: '0000',
    card_type: 'visa',
    expiry_date: '06/2029',
    balance: '00.0',
  };
  useEffect(() => {
    if (!confirmDeletePaymentMethodIsVisible) {
      setState(false);
    }
  }, [requestingDeletePaymentMethod]);

  const handleInitiateDeletePaymentMethod = (event) => {
    event.stopPropagation();
    initiateDeletePaymentMethod(paymentMethod?.id);
  };

  const renderCardIconClassName = () => {
    switch (card_type) {
      case 'master':
      case 'mastercard':
        return 'https://s3.amazonaws.com/assets.smoothpay.com/web/general-web-ordering-assets/mc-symbol-opt-45-3-x%403x.png';
      case 'visa':
        return 'https://s3.amazonaws.com/assets.smoothpay.com/web/general-web-ordering-assets/Visa-POS-Graphic_visa_pos_fc.png';
      case 'discover':
        return 'https://s3.amazonaws.com/assets.smoothpay.com/web/general-web-ordering-assets/discover_logo.jpg';
      case 'amex':
        return 'https://s3.amazonaws.com/assets.smoothpay.com/web/general-web-ordering-assets/AXP_BlueBoxLogo_EXTRALARGEscale_RGB_DIGITAL_1600x1600.png';
    }
  };
  const classes = useStyles();
  const cvvInputRef = useRef(null);

  return (
    <PaymentMenthodWrapper>
      {editStateIsVisible && (
        <RemoveIconMobile
          id='PaymentMethodPreview-Mobile-RemoveIcon'
          onClick={handleInitiateDeletePaymentMethod}
          className='fas fa-minus-circle'
        />
      )}
      <Wrapper
        editStateIsVisible={editStateIsVisible}
        isForCheckoutPage={isForCheckoutPage}
        onClick={(e) => {
          e.stopPropagation();
          if (paymentMethod?.is_preferred && cvvRequired) {
            setTimeout(() => {
              if (cvvInputRef.current) {
                cvvInputRef.current.focus();
              }
            }, 0);
          } else if (paymentMethod.type === 'gift_card' && !isForCheckoutPage) {
            showGiftCardModal(true);
            initiateReloadGiftCard(true);
            reloadGiftCard(paymentMethod);
          } else {
            setState(true);
          }
        }}
      >
        {editStateIsVisible &&
          paymentMethod &&
          paymentMethod.type !== 'gift_card' && (
            <RemoveIcon
              id='PaymentMethodPreview-RemoveIcon'
              onClick={handleInitiateDeletePaymentMethod}
              className='fas fa-minus-circle'
            />
          )}
        <CardWrapper>
          {card_type ? (
            <img
              src={renderCardIconClassName()}
              style={{ width: '50px' }}
              alt={card_type}
            />
          ) : (
            <i className='fas fa-gift-card' style={{ fontSize: '26px' }} />
          )}
          <Caption1 id='PaymentMethodPreview-GiftCard'>
            {paymentMethod && paymentMethod.type !== 'gift_card'
              ? `•••• `
              : `${appConfig.giftCardName} *`}
            {last_four}
          </Caption1>
        </CardWrapper>
        <Caption1 id='PaymentMethodPreview-ExpiryDate'>
          {expiry_date &&
            `EXP ${expiry_date.substring(5, 7)}/${expiry_date.substring(2, 4)}`}
          {paymentMethod &&
            paymentMethod.type === 'gift_card' &&
            `$${balance.toFixed(2)}`}
        </Caption1>
        {paymentMethod?.is_preferred && (
          <i className='fal fa-check' style={{ justifySelf: 'flex-end' }} />
        )}

        {paymentMethod?.is_preferred && cvvRequired && (
          <Box
            display='flex'
            justifyContent='center'
            alignItems='center'
            fullWidth
          >
            <TextField
              inputRef={cvvInputRef}
              value={cvv}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,4}$/.test(value)) {
                  setCvv(value);
                }
              }}
              id='cvv'
              label='CVV'
              placeholder='Enter CVV'
              variant='outlined'
              size='small'
              InputProps={{
                classes: {
                  root: classes.root,
                  input: classes.input,
                  notchedOutline: classes.notchedOutline,
                },
              }}
            />
          </Box>
        )}
        <PaymentMethodDetails
          open={state}
          handleClose={setState}
          details={paymentMethod?.details}
          paymentMethod={paymentMethod}
          initiateDeletePaymentMethod={initiateDeletePaymentMethod}
          setDefaultPaymentMethod={setDefaultPaymentMethod}
          is_preferred={paymentMethod?.is_preferred}
          showPaymentMethodSelectionForm={showPaymentMethodSelectionForm}
        />
      </Wrapper>
    </PaymentMenthodWrapper>
  );
};

export default PaymentMethodPreview;
